import React from 'react';

export default _ => <h1> Chargement ... </h1>;